import {computed, ref} from "vue";

const optionsMap = new Map();

export function useIncludeExcludeOptions(totalOptions, instanceId = 'default') {
    if (!optionsMap.has(instanceId)) {
        optionsMap.set(instanceId, ref({
            include: [],
            exclude: []
        }));
    }

    const options = optionsMap.get(instanceId);

    const allOptionsAreIncluded = computed(() => {
        return (options.value.include.includes('*')  && options.value.exclude.length === 0) || options.value.include.length === totalOptions.value;
    });

    const isUidObject = (value) => typeof value === 'object' && value !== null && 'uid' !== undefined;

    const itemExists = (array, itemToFind) => {
        if (isUidObject(itemToFind)) {
            return array.some(existing => isUidObject(existing) && existing.uid === itemToFind.uid);
        }
        return array.includes(itemToFind);
    };

    const removeItem = (array, valueToRemove) => {
        if (isUidObject(valueToRemove)) {
            return array.filter(item => !isUidObject(item) || item.uid !== valueToRemove.uid);
        }
        return array.filter(item => item !== valueToRemove);
    };

    function include(value) {
        if (value === '*') {
            includeAll();
            return;
        }

        if (Array.isArray(value)) {
            value.forEach((v) => {
                include(v);
            });
            return;
        }

        if ((allOptionsAreIncluded.value || options.value.include.includes('*')) && itemExists(options.value.exclude, value)) {
            options.value.exclude = removeItem(options.value.exclude, value);
            return;
        }

        if (!options.value.include.includes('*') && !itemExists(options.value.include, value)) {
            options.value.include.push(value);
        }
    }

    function exclude(value){
        if (allOptionsAreIncluded.value || options.value.include.includes('*')) {
            if(totalOptions.value === 1) {
                excludeAll();
                return;
            }
            if (!itemExists(options.value.exclude, value)) {
                options.value.exclude.push(value);
            }
        } else {
            options.value.include = removeItem(options.value.include, value);
        }
    }

    function includeAll() {
        options.value.include = ['*'];
        options.value.exclude = [];
    }

    function excludeAll() {
        options.value.include = [];
        options.value.exclude = [];
    }

    function isExcluded(value) {
        return itemExists(options.value.exclude, value);
    }

    function isIncluded(value) {
        if (allOptionsAreIncluded.value || options.value.include.includes('*')) {
            return !isExcluded(value);
        }

        return itemExists(options.value.include, value);
    }

    function resetIncludeExclude() {
        options.value = {
            include: [],
            exclude: []
        }
    }


    return {
        options,
        allOptionsAreIncluded,
        include,
        exclude,
        isIncluded,
        isExcluded,
        includeAll,
        excludeAll,
        resetIncludeExclude,
    }
}
